// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/connections/firstparty/v2/deactivate_connection.proto

/* eslint-disable */
import { ApiResponseData } from "./common";

/** Represents a deactivation reason code. */
export const ApiDeactivationReasonCode = {
  /**
   * deactivation_reason_code_unspecified - The deactivation reason code is not specified.
   */
  deactivation_reason_code_unspecified: "deactivation_reason_code_unspecified",
  /**
   * deactivation_reason_code_fees_too_expensive - Fees are too expensive.
   */
  deactivation_reason_code_fees_too_expensive: "deactivation_reason_code_fees_too_expensive",
  /**
   * deactivation_reason_code_settlement_delay - Settlement or payment takes too long.
   */
  deactivation_reason_code_settlement_delay: "deactivation_reason_code_settlement_delay",
  /**
   * deactivation_reason_code_activated_by_mistake - Activated by mistake.
   */
  deactivation_reason_code_activated_by_mistake: "deactivation_reason_code_activated_by_mistake",
  /**
   * deactivation_reason_code_connected_wrong_account - Connected to the wrong account.
   */
  deactivation_reason_code_connected_wrong_account: "deactivation_reason_code_connected_wrong_account",
  /**
   * deactivation_reason_code_prefer_bank_transfers - Prefers bank transfers.
   */
  deactivation_reason_code_prefer_bank_transfers: "deactivation_reason_code_prefer_bank_transfers",
  /**
   * deactivation_reason_code_setup_too_complicated - Setup or onboarding is too complicated.
   */
  deactivation_reason_code_setup_too_complicated: "deactivation_reason_code_setup_too_complicated",
  /**
   * deactivation_reason_code_data_security_concerns - Data security or sharing concerns.
   */
  deactivation_reason_code_data_security_concerns: "deactivation_reason_code_data_security_concerns",
  /**
   * deactivation_reason_code_no_longer_needed - No longer needed.
   */
  deactivation_reason_code_no_longer_needed: "deactivation_reason_code_no_longer_needed",
  /**
   * deactivation_reason_code_other - Other reason.
   */
  deactivation_reason_code_other: "deactivation_reason_code_other",
} as const;

export type ApiDeactivationReasonCode = typeof ApiDeactivationReasonCode[keyof typeof ApiDeactivationReasonCode];

export namespace ApiDeactivationReasonCode {
  export type deactivation_reason_code_unspecified =
    typeof ApiDeactivationReasonCode.deactivation_reason_code_unspecified;
  export type deactivation_reason_code_fees_too_expensive =
    typeof ApiDeactivationReasonCode.deactivation_reason_code_fees_too_expensive;
  export type deactivation_reason_code_settlement_delay =
    typeof ApiDeactivationReasonCode.deactivation_reason_code_settlement_delay;
  export type deactivation_reason_code_activated_by_mistake =
    typeof ApiDeactivationReasonCode.deactivation_reason_code_activated_by_mistake;
  export type deactivation_reason_code_connected_wrong_account =
    typeof ApiDeactivationReasonCode.deactivation_reason_code_connected_wrong_account;
  export type deactivation_reason_code_prefer_bank_transfers =
    typeof ApiDeactivationReasonCode.deactivation_reason_code_prefer_bank_transfers;
  export type deactivation_reason_code_setup_too_complicated =
    typeof ApiDeactivationReasonCode.deactivation_reason_code_setup_too_complicated;
  export type deactivation_reason_code_data_security_concerns =
    typeof ApiDeactivationReasonCode.deactivation_reason_code_data_security_concerns;
  export type deactivation_reason_code_no_longer_needed =
    typeof ApiDeactivationReasonCode.deactivation_reason_code_no_longer_needed;
  export type deactivation_reason_code_other = typeof ApiDeactivationReasonCode.deactivation_reason_code_other;
}

export function apiDeactivationReasonCodeFromJSON(object: any): ApiDeactivationReasonCode {
  switch (object) {
    case 0:
    case "deactivation_reason_code_unspecified":
      return ApiDeactivationReasonCode.deactivation_reason_code_unspecified;
    case 1:
    case "deactivation_reason_code_fees_too_expensive":
      return ApiDeactivationReasonCode.deactivation_reason_code_fees_too_expensive;
    case 2:
    case "deactivation_reason_code_settlement_delay":
      return ApiDeactivationReasonCode.deactivation_reason_code_settlement_delay;
    case 3:
    case "deactivation_reason_code_activated_by_mistake":
      return ApiDeactivationReasonCode.deactivation_reason_code_activated_by_mistake;
    case 4:
    case "deactivation_reason_code_connected_wrong_account":
      return ApiDeactivationReasonCode.deactivation_reason_code_connected_wrong_account;
    case 5:
    case "deactivation_reason_code_prefer_bank_transfers":
      return ApiDeactivationReasonCode.deactivation_reason_code_prefer_bank_transfers;
    case 6:
    case "deactivation_reason_code_setup_too_complicated":
      return ApiDeactivationReasonCode.deactivation_reason_code_setup_too_complicated;
    case 7:
    case "deactivation_reason_code_data_security_concerns":
      return ApiDeactivationReasonCode.deactivation_reason_code_data_security_concerns;
    case 8:
    case "deactivation_reason_code_no_longer_needed":
      return ApiDeactivationReasonCode.deactivation_reason_code_no_longer_needed;
    case 9:
    case "deactivation_reason_code_other":
      return ApiDeactivationReasonCode.deactivation_reason_code_other;
    default:
      return ApiDeactivationReasonCode.deactivation_reason_code_unspecified;
  }
}

export function apiDeactivationReasonCodeToJSON(object: ApiDeactivationReasonCode): string {
  switch (object) {
    case ApiDeactivationReasonCode.deactivation_reason_code_unspecified:
      return "deactivation_reason_code_unspecified";
    case ApiDeactivationReasonCode.deactivation_reason_code_fees_too_expensive:
      return "deactivation_reason_code_fees_too_expensive";
    case ApiDeactivationReasonCode.deactivation_reason_code_settlement_delay:
      return "deactivation_reason_code_settlement_delay";
    case ApiDeactivationReasonCode.deactivation_reason_code_activated_by_mistake:
      return "deactivation_reason_code_activated_by_mistake";
    case ApiDeactivationReasonCode.deactivation_reason_code_connected_wrong_account:
      return "deactivation_reason_code_connected_wrong_account";
    case ApiDeactivationReasonCode.deactivation_reason_code_prefer_bank_transfers:
      return "deactivation_reason_code_prefer_bank_transfers";
    case ApiDeactivationReasonCode.deactivation_reason_code_setup_too_complicated:
      return "deactivation_reason_code_setup_too_complicated";
    case ApiDeactivationReasonCode.deactivation_reason_code_data_security_concerns:
      return "deactivation_reason_code_data_security_concerns";
    case ApiDeactivationReasonCode.deactivation_reason_code_no_longer_needed:
      return "deactivation_reason_code_no_longer_needed";
    case ApiDeactivationReasonCode.deactivation_reason_code_other:
      return "deactivation_reason_code_other";
    default:
      return "deactivation_reason_code_unspecified";
  }
}

/** Request message for DeactivateConnectionRequest. */
export interface ApiDeactivateConnectionRequest {
  /** The unique identifier for the connection (from path parameter). */
  readonly id: string;
  /** The data wrapper by JSONAPI spec. */
  readonly data: ApiRequestData | null;
}

/** The data wrapper by JSONAPI spec. */
export interface ApiRequestData {
  /** The type of the resource which is mollie_connections. */
  readonly type: string;
  /** The deactivation request attributes. */
  readonly attributes: ApiDeactivationRequestAttributes | null;
}

/** Request message attributes for DeactivateConnectionRequest. */
export interface ApiDeactivationRequestAttributes {
  /** The deactivation reason. */
  readonly deactivationReason: ApiDeactivationReason | null;
}

/** Represents a deactivation reason. */
export interface ApiDeactivationReason {
  /** The deactivation reason code. */
  readonly code: ApiDeactivationReasonCode;
  /**
   * The deactivation reason details.
   * If code is deactivation_reason_code_other, this field is required and must have min: 1 and max: 225 characters.
   * details with space characters only will not be considered valid.
   */
  readonly details?: string | null | undefined;
}

/** Response message for DeactivateConnection. */
export interface ApiDeactivateConnectionResponse {
  /** The data wrapper by JSONAPI spec. */
  readonly data: ApiResponseData | null;
}

export const ApiDeactivateConnectionRequest: MessageFns<ApiDeactivateConnectionRequest> = {
  fromJSON(object: any): ApiDeactivateConnectionRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      data: isSet(object.data) ? ApiRequestData.fromJSON(object.data) : null,
    };
  },

  toJSON(message: ApiDeactivateConnectionRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.data !== undefined && message.data !== null) {
      obj.data = ApiRequestData.toJSON(message.data);
    }
    return obj;
  },
};

export const ApiRequestData: MessageFns<ApiRequestData> = {
  fromJSON(object: any): ApiRequestData {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      attributes: isSet(object.attributes) ? ApiDeactivationRequestAttributes.fromJSON(object.attributes) : null,
    };
  },

  toJSON(message: ApiRequestData): unknown {
    const obj: any = {};
    if (message.type !== undefined && message.type !== null) {
      obj.type = message.type;
    }
    if (message.attributes !== undefined && message.attributes !== null) {
      obj.attributes = ApiDeactivationRequestAttributes.toJSON(message.attributes);
    }
    return obj;
  },
};

export const ApiDeactivationRequestAttributes: MessageFns<ApiDeactivationRequestAttributes> = {
  fromJSON(object: any): ApiDeactivationRequestAttributes {
    return {
      deactivationReason: isSet(object.deactivation_reason)
        ? ApiDeactivationReason.fromJSON(object.deactivation_reason)
        : null,
    };
  },

  toJSON(message: ApiDeactivationRequestAttributes): unknown {
    const obj: any = {};
    if (message.deactivationReason !== undefined && message.deactivationReason !== null) {
      obj.deactivation_reason = ApiDeactivationReason.toJSON(message.deactivationReason);
    }
    return obj;
  },
};

export const ApiDeactivationReason: MessageFns<ApiDeactivationReason> = {
  fromJSON(object: any): ApiDeactivationReason {
    return {
      code: isSet(object.code)
        ? apiDeactivationReasonCodeFromJSON(object.code)
        : ApiDeactivationReasonCode.deactivation_reason_code_unspecified,
      details: isSet(object.details) ? globalThis.String(object.details) : null,
    };
  },

  toJSON(message: ApiDeactivationReason): unknown {
    const obj: any = {};
    if (message.code !== undefined && message.code !== null) {
      obj.code = apiDeactivationReasonCodeToJSON(message.code);
    }
    if (message.details !== undefined && message.details !== null) {
      obj.details = message.details;
    }
    return obj;
  },
};

export const ApiDeactivateConnectionResponse: MessageFns<ApiDeactivateConnectionResponse> = {
  fromJSON(object: any): ApiDeactivateConnectionResponse {
    return { data: isSet(object.data) ? ApiResponseData.fromJSON(object.data) : null };
  },

  toJSON(message: ApiDeactivateConnectionResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined && message.data !== null) {
      obj.data = ApiResponseData.toJSON(message.data);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
